import { useState, useEffect, forwardRef, useRef, Fragment } from 'react'

import {
    Divider,
    Grid,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableBody,
    Button,
    IconButton,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Slide,
    Box,
    Typography
} from '@mui/material';
import _ from 'lodash';
import { useSnackbar } from 'notistack';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import DeleteIcon from '@mui/icons-material/Delete';

import CustomLayout from 'views/CustomLayout'
import CustomBreadcrumbs from "components/Breadcrumbs";
import Loader from 'components/Loader';
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from 'constants/routeConstants';
import { useNavigate } from 'react-router-dom';
import { updateCartCount } from 'utils/website';
import { GLOBAL_CURRENCY } from 'constants/appConstants';
import { getAccessToken } from 'utils';
import {
    updateCartItemsToLocalStorage,
    removeCartItemsFromLocalStorage,
    clearCart,
    getCartItemsFromLocalStorage,
    getCartSummaryFromLocalStorage
} from 'utils/cart';
import { handleOpenAuthDialog } from 'utils/auth';
import { useSelector } from 'react-redux';
import CartItemNote from './OrderNotes';
import { useModal } from 'utils/SignupContext';
import FloatingCartBar from './CartFooter';
import { customeStyle } from 'utils/style';
import { useCart } from 'utils/CartContext';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { formatCurrencyNew } from 'utils/helper';
import PilotPOSOption from './PilotPOSOption';
import AllowedDomainss from './AllowedDomains';
import { useStore } from 'utils/OfflineContext';
let formatCurrency = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: GLOBAL_CURRENCY.code,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2
});

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const Cart = ({ breadcrumbs }) => {
    // const { couponctx, orderNotesctx, updateCouponctx, saveNotectx } = useCart();
    const { pilotPOSContext, setPilotPOSContext } = useStore()
    const { messagefroAuth, couponctx, orderNotesctx, updateCouponctx, setmessagefroAuth, saveNotectx } = useCart();
    const [loader, setLoader] = useState(false);
    const [cartItems, setCartItems] = useState([]);
    const [cartSubTotal, setSubTotal] = useState('');
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [couponCode, setCouponCode] = useState();
    const [appliedCouponCode, applyCouponCode] = useState();
    const [cartSummary, setCartSummary] = useState();
    const [askLogin, openAskLogin] = useState(false);
    const [showEmpty, setEmptyCart] = useState(false);
    const [orderNotes, setOrderNotes] = useState([]);

    const { isOpen, openModal, closeModal } = useModal();
    const webDetails = useSelector(state => state.webDetails);
    const { websiteInfo } = webDetails;
    const { user } = useSelector(state => state.userDetails);
    const prevUserRef = useRef(user);

    var token = getAccessToken();
    const [pilotPOS, setPilotPOS] = useState(false); // default

    const handlePilotChange = (event) => {
        setPilotPOS(event.target.value);
    };
    useEffect(() => {
        if (_.isEmpty(prevUserRef.current) && !_.isEmpty(user)) {
            let cartItem = getCartItemsFromLocalStorage();
            if (!_.isEmpty(cartItem)) syncCartFromLocalStorage()
            else getCartItems()
        }
        prevUserRef.current = user;
    }, [user])

    const syncCartFromLocalStorage = async () => {
        setLoader(true)
        let cartItems = getCartItemsFromLocalStorage();
        cartItems = _.map(cartItems, product => ({
            product: product.id,
            quantity: product.quantity
        }))
        let res = await axiosInstance.post(APIRouteConstants.DASHBOARD.UPDATE_CART_ITEMS_LOCAL_STORAGE, cartItems);
        let { data, response } = res;

        if (!_.isEmpty(data)) {
            clearCart()
            getCartItems()
            updateCartCount(true);
        }
    }

    const getCartItems = async () => {
        setLoader(true)
        let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.GET_CART_ITEMS);
        let { data, response } = res;

        if (data && data.cart_items) {
            console.log("config", data?.cart_items, data?.cart_items?.length == 0
            )
            if (data?.cart_items?.length == 0) {
                setEmptyCart(true)
                setCartItems([]);
            } else {
                setEmptyCart(false)
                setCartItems(data.cart_items);
            }
            getOutOfStock(data.cart_items)
            setSubTotal(data.subtotal_price);
        }
        getCartSummary()
        setLoader(false)
    }

    const getCartItemsFromLS = () => {
        let items = getCartItemsFromLocalStorage()

        setCartItems(items)
        if (items.length == 0) setEmptyCart(true)
        setCartSummary(items)
        getOutOfStock(cartItems)
    }
    function calculateTotalPrice(products) {
        return products.reduce((total, product) => {
            return total + parseFloat(product.price) * product.quantity;
        }, 0);
    }

    const updateCartItems = async (cartItemId, action) => {
        setLoader(true)
        let res = await axiosInstance.put(APIRouteConstants.DASHBOARD.UPDATE_CART_ITEMS(cartItemId), null, {
            params: { action: action },
        });
        let { data, response } = res;

        if (data) {
            getCartItems();
            getCartSummary();
            updateCartCount(true);
        }
    }

    const updateCartItemsToLS = (product, action) => {
        updateCartItemsToLocalStorage(product, action)
        updateCartCount(true);
        getCartItemsFromLS()
    }

    const removeCartItem = async (cartItemId) => {
        setLoader(true)
        let res = await axiosInstance.post(APIRouteConstants.DASHBOARD.REMOVE_CART_ITEMS(cartItemId));
        let { data, response } = res;

        if (data) {
            getCartItems();
            getCartSummary();
            updateCartCount(true);
        }
    }

    const deleteCartItemFromLocalStorage = (product) => {
        removeCartItemsFromLocalStorage(product)
        updateCartCount(true);
        getCartItemsFromLS()
    }

    const [successMsg, setSuccessMsg] = useState(null)
    const [errorMsg, setErrorMsg] = useState(null)
    // For vouchers
    const getCartSummary = async (coupon) => {
        try {
            setLoader(true)
            let queryParam = {}

            if (coupon) {
                localStorage.setItem("vouchercode", couponCode)
                queryParam['voucher_code'] = coupon
            }
            else if (appliedCouponCode && !coupon) queryParam['voucher_code'] = appliedCouponCode
            queryParam['delivery_option'] = websiteInfo?.delivery_option && websiteInfo?.delivery_option?.includes("shipping") ? "shipping" : "store_pickup"
            let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.CART_SUMMARY, {
                params: queryParam,
            })
            let { data, response } = res;

            if (data) {
                setCouponCode('')
                updateCouponctx('')
            }

            if (response && response.status == 400) {
                // enqueueSnackbar(response?.data?.detail ||'coupon not valid.', { variant: 'error' });
                setErrorMsg(response?.data?.detail || 'Voucher not found with the specified code or not valid.')
                localStorage.removeItem("vouchercode")
                setCouponCode('')
                updateCouponctx('')
                getCartSummary();
            }

            if (!_.isEmpty(data)) {
                setCartSummary(data)
                if (coupon && data?.coupon && data?.coupon_discount != 0) {
                    setSuccessMsg("Voucher applied successfully.")
                    setmessagefroAuth("")
                    // enqueueSnackbar('coupon applied successfully.', { variant: 'success' });
                    // setCouponCode('')
                    // updateCouponctx('')
                    //  localStorage.removeItem("vouchercode") 
                }
                if (coupon) applyCouponCode(coupon)
                setLoader(false)
            }
            if (res.status === 500) {
                enqueueSnackbar('something went wrong.', { variant: 'error' });
            }
            setLoader(false)
        } catch (err) {
            console.log("error", err)
            setLoader(false)
        }
    }

    const [outOfStock, setOutOfStock] = useState(false);

    const getOutOfStock = (items) => {
        let isOutOfStock = false;
        for (let item of items) {
            if (item.quantity > item.count) {
                isOutOfStock = true;
            }
        }
        setOutOfStock(isOutOfStock)
    }

    const saveNote = (id, note, Item) => {
        setOrderNotes((prevNotes) => {
            const existingNoteIndex = prevNotes.findIndex((item) => item.product_id === id);

            if (existingNoteIndex !== -1) {
                // If the note exists, update it
                const updatedNotes = [...prevNotes];
                updatedNotes[existingNoteIndex].order_instruction = note;
                return updatedNotes;
            } else {
                // If it doesn’t exist, add a new one
                return [...prevNotes, { product_id: id, order_instruction: note }];
            }
        });
    };

    function transformData(input) {
        console.log("transformData", input)
        return Object.keys(input).map(key => {
            return {
                product_id: key,
                order_instruction: input[key]?.order_instruction
            };
        });
    }

    function validateOrderNotes(cartItems, ordernotcontxtdata) {
        // Case 1: nothing to check → valid
        if (!cartItems?.length || !ordernotcontxtdata?.length) return true;

        const cartIDs = cartItems.map(i => i?.product_variant);

        // Case 2: loop through order note data
        for (const noteItem of ordernotcontxtdata) {
            const { product_id, order_instruction } = noteItem;

            const isItemInCart = cartIDs.includes(Number(product_id));
            console.log("ordernotcontxtdata", cartIDs, isItemInCart, product_id, order_instruction)
            // If product is in cart and order_instruction exists → invalid
            if (isItemInCart && (!order_instruction || order_instruction.trim() === "")) {
                return false; // ❌ not valid because note is missing
            }
        }

        return true; // ✔ all notes are filled → valid
    }


    const checkoutCart = async () => {
        setLoader(true);
        setErrorMsg('')
        let formData = {};
        if (websiteInfo?.order_note_required === true) {
            const ordernotcontxtdata = transformData(orderNotesctx)
            const isValid = validateOrderNotes(cartItems, ordernotcontxtdata);

            if (!isValid) {
                enqueueSnackbar('Please add order notes for all products.', { variant: 'error' })
                setLoader(false);
                setErrorMsg('Please add order notes for all products.')
                return
            }
        }
        // Retrieve full table number from local storage
        let tableNumber = localStorage.getItem("number");

        console.log("Number before checkout:", tableNumber);

        // Include "number" in API request only if available
        if (tableNumber) {
            formData["number"] = tableNumber;
        }

        // Retrieve voucher code if available
        const codeV = localStorage.getItem("vouchercode");
        if (couponCode || appliedCouponCode || codeV) {
            formData["voucher_code"] = couponCode || appliedCouponCode || codeV;
        }


        // Add order notes if available 
        const ordernotcontxtdata = transformData(orderNotesctx)

        if (ordernotcontxtdata?.length > 0) {
            formData["products"] = orderNotes;
        }
        if (ordernotcontxtdata?.length > 0) {
            formData["products"] = ordernotcontxtdata;
        }
        if (pilotPOS === true) {
            formData["is_pilot_order"] = pilotPOS;
        }

        // Send API request
        let res = await axiosInstance.post(APIRouteConstants.DASHBOARD.CHECKOUT, formData);

        if (res && res?.response && res.status == 404 || res.status == 400) {
            console.log("API Response for Checkout:", res, res?.response?.data?.error);
            console.log(res, 'RESPONSEEEEEE')
            if (res.response.data.error === "Invalid sequence number") {
                enqueueSnackbar('Invalid QR code, try again.', { variant: 'error' })
                setLoader(false);
                return;
            }
            if (couponCode) {
                console.log(res, 'RESPONSEEEEEE')
                // enqueueSnackbar(res?.data?.detail ||'coupon not valid.', { variant: 'error' });
                setErrorMsg(res?.response?.data?.message || res?.response?.data?.detail || 'Voucher not found with the specified code or not valid.')
                setCouponCode('')
                updateCouponctx('')
                setLoader(false);
            }
            console.log(websiteInfo, 'RESPONSEEEEEE')
            if (websiteInfo?.order_note_required) {

                enqueueSnackbar(res?.response?.data?.error, { variant: 'error' })
                setLoader(false);
                return
            }
            enqueueSnackbar('There is some issue while checkout, Please try again..', { variant: 'error' })
            setLoader(false);
            setCouponCode('')
            updateCouponctx('')
        }
        if (res.data) {
            if (res?.data?.pilot_response != null && res?.data?.pilot_response?.response?.Status === true) {

                console.log("object", res?.data?.pilot_response != null && res?.data?.pilot_response?.response?.Status === true)
                enqueueSnackbar('Order sent to Pilot POS successfully.', { variant: 'success' });
                navigate(`/order-status?orderid=${res?.data?.transaction_id}`, { state: { order: res?.data } });
                // setTimeout(() => {
                //     window.location.reload();
                // }, 300);
            } else {
                navigate("/checkout", {
                    state: { orderId: res.data.transaction_id }
                });
            }
        }

        setLoader(false);
    };

    useEffect(() => {
        setErrorMsg("")
        setmessagefroAuth("")
        if (token)
            getCartItems()
        else
            getCartItemsFromLS()
    }, [])

    const [isWebsiteFunctional, setIsWebsiteFunctional] = useState(false);
    const [hasCheckedWebsiteInfo, setHasCheckedWebsiteInfo] = useState(false); // 🔹 new flag


    const getWebsiteInfo = async () => {
        setLoader(true);
        try {
            const res = await axiosInstance.get(APIRouteConstants.DASHBOARD.WEB_INFO);
            const { data } = res;
            setIsWebsiteFunctional(data.status);

            setPilotPOS(data?.is_pilot_active)
            setPilotPOSContext(data?.is_pilot_active)
        } catch (err) {
            console.error(err);
            setIsWebsiteFunctional(false);
        } finally {
            setLoader(false);
            setHasCheckedWebsiteInfo(true); // ✅ mark check as complete
        }
    };
    useEffect(() => {
        getWebsiteInfo();
    }, []);




    return (
        <CustomLayout>
            <Loader open={loader} />
            <div className="content-container">
                <CustomBreadcrumbs list={breadcrumbs} name={"Cart"} />
                <Divider className="divider" />
                <Grid container className="cart-wrapper main-content-wrapper">

                    <Grid container className="stepper-header">
                        <div className='stepper-header-content'>
                            <span className='active'>
                                SHOPPING CART
                            </span>
                            <ArrowForwardIcon style={{ marginBottom: '-3px', fontSize: '1.5rem' }} />
                            <span className='inactive' style={{ fontSize: '1.6rem' }}>
                                CHECKOUT
                            </span>
                            <ArrowForwardIcon style={{ marginBottom: '-3px', fontSize: '1.5rem' }} />
                            <span className='inactive' style={{ fontSize: '1.6rem' }}>
                                ORDER COMPLETE
                            </span>
                        </div>
                    </Grid>

                    {websiteInfo?.order_note_required && <AllowedDomainss orderinstruction={websiteInfo?.w_order_instruction} />}
                    {(showEmpty) ? <Grid container className="empty-wrapper">
                        <div className="icon-wrapper">
                            <AddShoppingCartIcon />
                        </div>
                        <span className="title">
                            YOUR CART IS CURRENTLY EMPTY
                        </span> <br />
                        <span className="description">
                            Please add some products to your shopping cart before proceeding to checkout.
                        </span>
                        <span className="description">
                            Browse our shop categories to discover new arrivals and special offers.
                        </span>
                        <div className='button-wrapper'>
                            <Button variant="contained" href='/products'>
                                RETURN TO SHOP
                            </Button>
                        </div>
                    </Grid> :
                        <Grid container className="cart-content" spacing={10}>
                            <Grid item xs={12} sm={12} md={12} lg={8}>
                                <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                                    <TableContainer component={Paper} className='cart-table'>
                                        <Table aria-label="simple table">
                                            <TableHead className='cart-table-header'>
                                                <TableRow>
                                                    <TableCell width="60%" padding="normal">
                                                        <Typography sx={{ fontSize: customeStyle.typography.subhading1 }} variant="h6">
                                                            PRODUCT
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Typography sx={{ fontSize: customeStyle.typography.subhading1 }} variant="h6">
                                                            QUANTITY
                                                        </Typography>

                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Typography sx={{ fontSize: customeStyle.typography.subhading1 }} variant="h6">
                                                            SUBTOTAL
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {cartItems.map((item, i) =>
                                                    <Fragment key={i}>

                                                        <TableRow key={i}>
                                                            <TableCell sx={{ borderBottom: "none" }}>
                                                                <div className='product-detail'   >
                                                                    <div className='icon-wrapper'>
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                if (token)
                                                                                    removeCartItem(item.id)
                                                                                else
                                                                                    deleteCartItemFromLocalStorage(item)
                                                                            }}
                                                                            aria-label="close" >
                                                                            <CloseIcon />
                                                                        </IconButton>
                                                                    </div>
                                                                    <div
                                                                        className={item.count == 0 || item.count < item.quantity ? 'greyout image-wrapper' : 'image-wrapper'}
                                                                    >

                                                                        <img src={item?.product_image || item?.images?.[0]?.image || item?.images?.[0]?.image_url} alt={item.product_name || item.name} />
                                                                    </div>
                                                                    <div className="detail-wrapper">


                                                                        <Typography sx={{ fontSize: customeStyle.buttomfont }} className='title' >
                                                                            {_.truncate(item.product_name || item.name, { length: 40 })}
                                                                        </Typography>

                                                                        {((item?.size &&
                                                                            item?.size !== '' &&
                                                                            item?.size !== 'null')) && <Typography sx={{ fontSize: customeStyle.buttomfont1 }} className="title">
                                                                                {(() => {
                                                                                    let size = "";

                                                                                    // Case 1: item.size.name exists and not empty
                                                                                    if (item?.size?.name?.trim()) {
                                                                                        size = item.size.name;
                                                                                    }
                                                                                    // Case 2: item.size is a string
                                                                                    else if (typeof item?.size === "string" && item.size.trim()) {
                                                                                        size = item.size;
                                                                                    }

                                                                                    return size ? `Size: ${_.truncate(size, { length: 40 })}` : "";
                                                                                })()}
                                                                            </Typography>}

                                                                        {((item?.color &&
                                                                            item?.color !== '' &&
                                                                            item?.color !== 'null')) && <Typography sx={{ fontSize: customeStyle.buttomfont1 }} className="title">
                                                                                {(() => {
                                                                                    let color = "";

                                                                                    // Case 1: item.color.name exists and not empty
                                                                                    if (item?.color?.name?.trim()) {
                                                                                        color = item.color.name;
                                                                                    }
                                                                                    // Case 2: item.color is a plain string
                                                                                    else if (typeof item?.color === "string" && item.color.trim()) {
                                                                                        color = item.color;
                                                                                    }

                                                                                    return color ? `Color: ${_.truncate(color, { length: 40 })}` : "";
                                                                                })()}
                                                                            </Typography>

                                                                        }

                                                                        <span>{formatCurrencyNew(item.product_price || item.price, websiteInfo?.currency_symbol)}</span>
                                                                        {item.count !== 0 && item.count < 6 ?
                                                                            <div className="inventory-text">
                                                                                <span>
                                                                                    Only {item.count} left
                                                                                </span>
                                                                            </div>
                                                                            : item.count == 0 ?
                                                                                <div className="inventory-text">
                                                                                    <span>
                                                                                        Out of Stock
                                                                                    </span>
                                                                                </div>
                                                                                : ''}
                                                                    </div>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ borderBottom: "none" }}>
                                                                <div className='button-group'>
                                                                    <Button
                                                                        onClick={() => {
                                                                            if (token) updateCartItems(item.id, 0)
                                                                            else updateCartItemsToLS(item, 0)
                                                                        }}
                                                                        variant="outlined"
                                                                        size="small">
                                                                        -
                                                                    </Button>
                                                                    <Button disabled variant="contained" size="small" >
                                                                        {item.quantity}
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() => {
                                                                            if (token) updateCartItems(item.id, 1)
                                                                            else updateCartItemsToLS(item, 1)
                                                                        }}
                                                                        className={item.count == 0 || item.count <= item.quantity ? 'greyout' : ''}
                                                                        disabled={item.count == 0 || item.count <= item.quantity}
                                                                        variant="outlined"
                                                                        size="small">
                                                                        +
                                                                    </Button>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell sx={{ borderBottom: "none" }} align="right" className={item.count == 0 || item.count < item.quantity ? 'greyout' : ''}>
                                                                <Typography sx={{ fontSize: customeStyle.buttomfont }} >
                                                                    <b>{formatCurrencyNew(item.product_subtotal_price || (item.price * item.quantity), websiteInfo?.currency_symbol)}</b>
                                                                </Typography>
                                                            </TableCell>

                                                            {/* <div className='overlay-card'>
                                                    <Button style={{ backgroundColor: 'rgba(255,255,255,0.8)' }} variant="outlined" color="error">
                                                        <b>Out of Stock</b>
                                                    </Button>
                                                </div> */}

                                                        </TableRow>
                                                        {/* <div className='overlay-card'>
                                                    <Button style={{ backgroundColor: 'rgba(255,255,255,0.8)' }} variant="outlined" color="error">
                                                    <b>Out of Stock</b>
                                                    </Button>
                                                    </div> */}

                                                        {item?.is_disabled && <Typography color={"red"} fontSize='0.6rem'>This product is no longer available — please remove it from your cart.</Typography>}
                                                        <CartItemNote item={item} itemId={item?.product_variant || item.product || item.id} onSave={(id, note) => saveNote(id, note)} />

                                                    </Fragment>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                                <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
                                    <TableContainer component={Paper} className='cart-table'>
                                        <Table aria-label="simple table">
                                            <TableBody>
                                                {cartItems.map((item, i) =>
                                                    <Fragment key={i}>

                                                        <TableRow key={i}>
                                                            <TableCell className='mobile-table-wrapper' sx={{ borderBottom: "none" }}>
                                                                <div className='product-detail'>
                                                                    <div
                                                                        className={item.count == 0 || item.count < item.quantity ? 'greyout image-wrapper' : 'image-wrapper'}
                                                                    >
                                                                        <img src={item?.product_image || item?.images?.[0]?.image || item?.images?.[0]?.image_url} alt={item.product_name || item.name} />
                                                                    </div>
                                                                    <div className="detail-wrapper">
                                                                        <span className='title'>
                                                                            {_.truncate(item.product_name || item.name, { length: 40 })}
                                                                        </span>
                                                                        <Grid display={'flex'} justifyContent={'flex-start'} alignItems={'center'} >

                                                                            {((item?.size &&
                                                                                item?.size !== '' &&
                                                                                item?.size !== 'null')) && <Typography sx={{ fontSize: customeStyle.buttomfont1 }} className="title">
                                                                                    {(() => {
                                                                                        let size = "";

                                                                                        // Case 1: item.size.name exists and not empty
                                                                                        if (item?.size?.name?.trim()) {
                                                                                            size = item.size.name;
                                                                                        }
                                                                                        // Case 2: item.size is a string
                                                                                        else if (typeof item?.size === "string" && item.size.trim()) {
                                                                                            size = item.size;
                                                                                        }

                                                                                        return size ? `Size: ${_.truncate(size, { length: 40 })}` : "";
                                                                                    })()}
                                                                                </Typography>}
                                                                            {((item?.color &&
                                                                                item?.color !== '' &&
                                                                                item?.color !== 'null')) &&
                                                                                <Typography sx={{ fontSize: customeStyle.buttomfont1 }} className="title">
                                                                                    {(() => {
                                                                                        let color = "";

                                                                                        // Case 1: item.color.name exists and not empty
                                                                                        if (item?.color?.name?.trim()) {
                                                                                            color = item.color.name;
                                                                                        }
                                                                                        // Case 2: item.color is a plain string
                                                                                        else if (typeof item?.color === "string" && item.color.trim()) {
                                                                                            color = item.color;
                                                                                        }

                                                                                        return color ? `Color: ${_.truncate(color, { length: 40 })}` : "";
                                                                                    })()}
                                                                                </Typography>

                                                                            }
                                                                        </Grid>
                                                                        <span>{formatCurrencyNew(item.product_price || item.price, websiteInfo?.currency_symbol)}</span>
                                                                        {item.count !== 0 && item.count < 6 ?
                                                                            <div className="inventory-text">
                                                                                <span>
                                                                                    Only {item.count} left
                                                                                </span>
                                                                            </div>
                                                                            : item.count == 0 ?
                                                                                <div className="inventory-text">
                                                                                    <span>
                                                                                        Out of Stock
                                                                                    </span>
                                                                                </div>
                                                                                : ''}
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>                                                            <div className='button-group'>
                                                                            <Button
                                                                                onClick={() => {
                                                                                    if (token) updateCartItems(item.id, 0)
                                                                                    else updateCartItemsToLS(item, 0)
                                                                                }}
                                                                                variant="outlined"
                                                                                size="small">
                                                                                -
                                                                            </Button>
                                                                            <Button disabled variant="contained" size="small">
                                                                                {item.quantity}
                                                                            </Button>
                                                                            <Button
                                                                                onClick={() => {
                                                                                    if (token) updateCartItems(item.id, 1)
                                                                                    else updateCartItemsToLS(item, 1)
                                                                                }}
                                                                                className={item.count == 0 || item.count <= item.quantity ? 'greyout' : ''}
                                                                                disabled={item.count == 0 || item.count <= item.quantity}
                                                                                variant="outlined"
                                                                                size="small">
                                                                                +
                                                                            </Button>
                                                                        </div>
                                                                            <span style={{ marginLeft: '1rem' }} className="price">
                                                                                <b>{formatCurrencyNew(item.product_subtotal_price || (item.price * item.quantity), websiteInfo?.currency_symbol)}</b>
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                    <div className='icon-wrapper'>
                                                                        <IconButton
                                                                            onClick={() => {
                                                                                if (token)
                                                                                    removeCartItem(item.id)
                                                                                else
                                                                                    deleteCartItemFromLocalStorage(item)
                                                                            }}
                                                                            aria-label="close" >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </div>
                                                                </div>
                                                            </TableCell>

                                                            {/* <div className='overlay-card'>
                                                    <Button style={{ backgroundColor: 'rgba(255,255,255,0.8)' }} variant="outlined" color="error">
                                                    <b>Out of Stock</b>
                                                    </Button>
                                                    </div> */}

                                                        </TableRow>

                                                        {item?.is_disabled && <Typography color={"red"} fontSize='0.6rem'>This product is no longer available — please remove it from your cart.</Typography>}

                                                        <CartItemNote item={item} itemId={item?.product_variant || item.product || item.id} onSave={(id, note) => saveNote(id, note)} />
                                                    </Fragment>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Grid>
                            <Grid item className='coupon-conatiner' xs={12} sm={12} md={12} lg={4}>
                                <Grid container className="coupon-wrapper">
                                    <Grid item xs={9}>
                                        <div className='form-wrapper'>
                                            <TextField
                                                margin="dense"
                                                id="custom-coupon-code"
                                                name="custom-coupon-code"
                                                placeholder="Coupon Code"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                autoComplete="new-password"
                                                defaultValue={couponCode || couponctx || ""}
                                                value={couponCode || couponctx || ""}
                                                // disabled={!token}
                                                // onBlur={() => }
                                                onChange={e => { setCouponCode(e.target.value); updateCouponctx(e.target.value) }}
                                                InputLabelProps={{ shrink: false, autoComplete: "new-password" }}
                                            />
                                        </div>
                                    </Grid>
                                    {/* <Grid item xs={3} className={!token ? 'greyout button-wrapper' : 'button-wrapper'}> */}
                                    {console.log("message", successMsg, errorMsg, couponCode)}
                                    <Grid item xs={3} className={!couponCode ? 'greyout button-wrapper' : 'button-wrapper'}>
                                        <Button
                                            variant="outlined"
                                            className='coupon-btn'
                                            disabled={!couponCode}
                                            onClick={() => {
                                                if (couponCode && !token) return
                                                setSuccessMsg(null)
                                                setErrorMsg(null)
                                                getCartSummary(couponCode)
                                            }}
                                        >
                                            APPLY
                                        </Button>
                                    </Grid>
                                    <Box display="flex" alignItems="center">
                                        {successMsg && (
                                            <Typography sx={{ fontSize: "0.8rem", color: "#4CAF50", display: 'flex', alignItems: 'center' }}>
                                                <CheckCircleIcon sx={{ mr: 1 }} />
                                                {successMsg}
                                            </Typography>
                                        )}
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                        {errorMsg ? (
                                            <Typography sx={{ fontSize: "0.8rem", color: "red", display: 'flex', alignItems: 'center' }}>
                                                <CancelIcon sx={{ mr: 1 }} />
                                                {errorMsg}
                                            </Typography>
                                            // )}
                                        ) : messagefroAuth ? (
                                            <Typography sx={{ fontSize: "0.8rem", color: "red", display: 'flex', alignItems: 'center' }}>
                                                <CancelIcon sx={{ mr: 1 }} />
                                                {messagefroAuth}
                                            </Typography>
                                        ) : null}
                                    </Box>
                                    {!token ?
                                        <Grid item xs={12} style={{ margin: '-0.5rem 0 1.5rem 0' }} className='error-text'>
                                            <span>*** Please <a style={{
                                                textDecoration: 'underline',
                                                cursor: 'pointer'
                                            }} onClick={openModal}>login</a> to apply additional offers.</span>
                                        </Grid> : ''}
                                </Grid>
                                <div className='cart-summary'>
                                    <Typography sx={{ fontSize: customeStyle.typography.subhading }}>
                                        CART TOTAL
                                    </Typography>
                                    <Divider className='divider' />
                                    {/* <div className='calc-wrapper'>
                                    <span className='description'>
                                        Total
                                    </span>
                                    <span className='description'>
                                        <b>{formatCurrency.format(_.get(cartSummary, 'cart_total'))}</b>
                                    </span>
                                </div>
                                <Divider className='divider'/>
                                <div className='calc-wrapper'>
                                    <span className='description'>
                                        Coupon
                                    </span>
                                    <span className='description'>
                                        <b>{formatCurrency.format(_.get(cartSummary, 'coupon_discount'))}</b>
                                    </span>
                                </div> */}
                                    {/* <Divider className='divider'/> */}
                                    {cartSummary?.coupon_discount > 0 && <div className='calc-wrapper'>
                                        <Typography className='description'>
                                            Subtotal
                                        </Typography>
                                        <span className='description'>
                                            <b>{formatCurrencyNew(_.get(cartSummary, 'cart_total'), websiteInfo?.currency_symbol)}</b>
                                        </span>
                                    </div>}
                                    {cartSummary?.Shipping > 0 && <div className='calc-wrapper'>
                                        <Typography className='description'>
                                            Shipping
                                        </Typography>
                                        <span className='description'>
                                            <b>{formatCurrencyNew(_.get(cartSummary, 'Shipping'), websiteInfo?.currency_symbol)}</b>
                                        </span>
                                    </div>}
                                    {cartSummary?.coupon_discount > 0 && <div className='calc-wrapper'>
                                        <Typography className='description'>
                                            Coupon Discount
                                        </Typography>
                                        <span className='description'>
                                            <b>{formatCurrencyNew(_.get(cartSummary, 'coupon_discount'), websiteInfo?.currency_symbol)}</b>
                                        </span>
                                    </div>}
                                    {cartSummary?.coupon_discount > 0 && <div className='calc-wrapper'>
                                        <Typography className='description'>
                                            Price after discount
                                        </Typography>
                                        <span className='description'>
                                            <b>{formatCurrencyNew(_.get(cartSummary, 'price_after_coupon'), websiteInfo?.currency_symbol)}</b>
                                        </span>
                                    </div>}
                                    <div className='calc-wrapper'>
                                        <Typography className='description'>
                                            Total
                                        </Typography>
                                        <span className="description">
                                            {(() => {
                                                const totalPrice = calculateTotalPrice(cartItems);
                                                const subTotal = _.get(cartSummary, 'sub_total', 0);

                                                // Check if the value is a valid number
                                                const isValidNumber = (val) => typeof val === "number" && !Number.isNaN(val);

                                                // Check for valid totalPrice or subTotal
                                                if ((isValidNumber(totalPrice) && totalPrice !== 0) || (isValidNumber(subTotal) && subTotal !== 0)) {
                                                    return (
                                                        <b>
                                                            {!token
                                                                ? (isValidNumber(totalPrice) && totalPrice !== 0 ? formatCurrencyNew(totalPrice, websiteInfo?.currency_symbol) : '')
                                                                : (isValidNumber(subTotal) && subTotal !== 0 ? formatCurrencyNew(subTotal, websiteInfo?.currency_symbol) : '')
                                                            }
                                                        </b>
                                                    );
                                                }
                                                return null; // If no valid price, return nothing
                                            })()}
                                        </span>

                                    </div>
                                    {outOfStock ?
                                        <div className='error-text'>
                                            <span>*** Some items from your cart are out of stock. Please review your cart.</span>
                                        </div> : ''}
                                    {/* {pilotPOS &&  <PilotPOSOption value={pilotPOS} onChange={handlePilotChange} />} */}
                                    <div className='button-wrapper'>
                                        {console.log("cartItems", cartItems)}
                                        <Button
                                            disabled={
                                                _.isEmpty(cartItems) ||
                                                outOfStock ||
                                                cartItems?.some((item) => item?.is_disabled === true)
                                                ||
                                                (hasCheckedWebsiteInfo && !isWebsiteFunctional)
                                            }
                                            variant="contained"
                                            onClick={() => {
                                                if (token) checkoutCart();
                                                else openModal();
                                            }}
                                            sx={{ fontSize: customeStyle.buttomfont }}
                                        >
                                            Proceed to checkout
                                        </Button>
                                    </div>

                                    {/* 🔴 Store Offline Notice */}
                                    {hasCheckedWebsiteInfo && !isWebsiteFunctional && (
                                        <div
                                            style={{
                                                marginTop: "12px",
                                                backgroundColor: "#FFEBEE",
                                                padding: "10px 12px",
                                                borderRadius: "6px",
                                                border: "1px solid #C62828",
                                                color: "#C62828",
                                                fontWeight: 600,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                fontSize: "0.95rem",
                                            }}
                                        >
                                            <span>⚠️</span>
                                            The store is currently offline. Please try again later.
                                        </div>
                                    )}

                                </div>
                            </Grid>
                        </Grid>}
                </Grid>
            </div>
            <Dialog
                open={askLogin}
                TransitionComponent={Transition}
                onClose={() => {

                }}
                className='login-dialog-wrapper'>
                <DialogTitle disableTypography className='login-dialog-title'>
                    <IconButton onClick={() => {
                        openAskLogin(false)
                    }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <DialogContentText id="alert-dialog-slide-description">
                        <span>Please Login to continue</span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className='dialog-action'>
                    <Button
                        variant='contained'
                        color="error"
                        size="small"
                        onClick={() => {
                            openAskLogin(false)
                            handleOpenAuthDialog(true)
                        }}
                    >
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
        </CustomLayout>
    )
}

export default Cart